module.exports = __webpack_public_path__ + "assets/8aea38f4c1b1a2a9b7c348a18ec4c086.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/MultiSweepBell.mp3
 ** module id = 220
 ** module chunks = 0
 **/